import script from "./TravelOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelOrder.vue?vue&type=script&setup=true&lang=js"

import "./TravelOrder.vue?vue&type=style&index=0&id=352bafb4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-352bafb4"]])

export default __exports__